import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux';
// import MyPDF from "frontend/ui_srk/public/Wz�rDla�wiaczeniodawcy.xlsx"
import {getCurrentUser} from 'actions/userActions';


import {getFileList, uploadFile} from 'actions/uploadFile'
// reactstrap components
import {
    Modal,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Label,
    CustomInput,
    Button,
    Row,
    Col,
} from "reactstrap";

// conponents
import FileTable from './FileTable'
import DataImportPage from '../DataImportPage';
import {getTemplateExcel} from "../../../../actions/uploadFile";


const ImportExcel = ({getFileList, uploadFile,getTemplateExcel, blob, getCurrentUser, currentUser}) => {
    const [UploadedFile, setUploadedFile] = useState({
        name: 'Wgraj plik excel z danymi',
        file: null
    });

    const handleFileInput = (file) => {
        setUploadedFile({
            name: file.name,
            file: file
        });
    };
    React.useEffect(()=>{
        getCurrentUser()
    },[])

    const handleSubmit = (event) => {
        event.preventDefault();
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            `file`,
            UploadedFile.file
        );
        formData.append(
            `name`,
            UploadedFile.name
        );

        uploadFile(formData)
        // setUploadedFile({
        //     name: 'Wgraj plik excel z danymi',
        //     file: null
        // });
    };

    return (
        <DataImportPage>
            <Row>
                <Col md={12} className={'ml-auto mr-auto'}>
                    <Card>
                        <CardBody>
                            <Form>
                                <FormGroup >
                                    {/* <Label for="import-excel">{`${fileName}`}</Label> */}
                                    <CustomInput style={{cursor:"pointer"}} className='importFile'
                                        type="file"
                                        id="import-excel"
                                        name="excelFile"
                                        label={`${UploadedFile.name}`}
                                        lang="pl"
                                        onChange={(e) => handleFileInput(e.target.files[0])}
                                        disabled={currentUser && currentUser.company === null}
                                    />
                                </FormGroup>
                                <Row>
                                    <Col xs="6">
                                        <Button style={{width: '230px'}}
                                            className="btn-round m-0" color="import" outline type="button"
                                            // block className={'btn-aotmit-gradient-reverse m-0'} 
                                            onClick={e=>{getTemplateExcel()}}>
                                            <i className="fas fa-download mr-2"/>
                                            Pobierz szablon pliku
                                        </Button>
                                    </Col>
                                    <Col className="text-right"  xs="6">
                                        <Button type='button' style={{width: '230px'}}
                                            onClick={(e) => handleSubmit(e)}
                                            // block className={'btn-aotmit-gradient m-0'}
                                            className="btn-round m-0" color="import" outline>
                                            <i className="fas fa-upload mr-2"/>
                                            Prześlij plik
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <FileTable/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </DataImportPage>
    )
}

const mapStateToProps = (state) => ({
    UploadFile: state.UploadFile,
    currentUser: state.UserReducer.currentUser

});

export default connect(mapStateToProps, {getFileList, uploadFile, getTemplateExcel, getCurrentUser})(ImportExcel)
